import {hovercardAttributesForActor} from '@github-ui/hovercards'
import {ProfileReference} from '@github-ui/profile-reference'
import type {RelayCompat} from '@github-ui/server-persisted-queries/relay-compat'
import {Link} from '@primer/react'

import {VALUES} from '../constants/values'
import styles from './assignees.module.css'
import type {AssignmentEventAssigneeNode} from './issue-viewer-view-query-types'

// RELAY-CLEANUP(UnassignedEvent): widens nullable fields so still-Relay UnassignedEvent data is assignable.
// Remove when UnassignedEvent leaves Relay.
export type AssignmentEventAssigneeFragment = RelayCompat<AssignmentEventAssigneeNode>

type AssignmentEventAssigneeProps = {
  assignee?: AssignmentEventAssigneeFragment | null
}

export function AssignmentEventAssignee({assignee}: AssignmentEventAssigneeProps): React.ReactElement {
  const assigneeLogin = assignee?.login || VALUES.ghost.login
  const isCopilot = assignee?.__typename === 'Bot' && (assignee.isCopilot ?? false)
  const isAgent = assignee?.__typename === 'Bot' && (assignee.isAgent ?? false)
  const isUser = assignee?.__typename === 'User' || assignee?.__typename === 'Organization'
  const showHovercard = isUser || isCopilot || isAgent
  const hovercardData = showHovercard ? hovercardAttributesForActor(assigneeLogin, {isCopilot, isAgent}) : {}
  const displayName = isCopilot
    ? VALUES.copilot.displayName
    : isAgent
      ? (assignee.displayName ?? assigneeLogin)
      : assigneeLogin || VALUES.ghost.login
  const profileName = assignee?.__typename === 'User' || assignee?.__typename === 'Mannequin' ? assignee.name : null
  return (
    <Link {...hovercardData} href={assignee?.resourcePath} className={styles.assigneeLink} inline>
      <ProfileReference login={displayName} profileName={profileName} isAgent={isAgent} />
    </Link>
  )
}
